import { enter, leave } from 'el-transition'
import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    'errorMessage',
    'filename',
    'fileInput',
    'form',
    'pendingOverlay',
    'retry',
    'successfulOverlay',
  ]

  static values = {
    errorMessage: String,
    genericError: String,
    invalidCharacterError: String,
    status: String,
  }

  connect() {
    this.updateFilename()
  }

  dismiss() {
    this.element.remove()
  }

  errorMessageValueChanged(value, previousValue) {
    if (value !== '') {
      this.errorMessageTarget.innerHTML = this.errorMessageValue
      enter(this.errorMessageTarget)
    } else if (previousValue !== undefined && value === '') {
      this.errorMessageTarget.innerHTML = ''
      leave(this.errorMessageTarget)
    }
  }

  retry(event) {
    event.preventDefault()
    this.dispatch('retry', { detail: { submitPromise: this.submit() } })
  }

  statusValueChanged() {
    switch (this.statusValue) {
      case 'error':
        leave(this.pendingOverlayTarget)
        enter(this.retryTarget)
        break
      case 'pending':
        enter(this.pendingOverlayTarget)
        leave(this.retryTarget)
        break
      case 'success':
        leave(this.pendingOverlayTarget)
        enter(this.successfulOverlayTarget)
        break
      default:
    }
  }

  async submit() {
    this.statusValue = 'pending'
    this.errorMessageValue = ''

    let response

    try {
      response = await post(
        this.formTarget.action,
        {
          body: new FormData(this.formTarget),
          responseKind: 'json',
        },
      )
    } catch (error) {
      this.errorMessageValue = this.genericErrorValue
      this.statusValue = 'error'

      return this.statusValue
    }

    if (response.ok) {
      this.statusValue = 'success'
    } else if (response.unprocessableEntity) {
      const data = await response.json
      this.errorMessageValue = data.error
      this.statusValue = 'error'
    }

    return this.statusValue
  }

  updateFilename() {
    const { files } = this.fileInputTarget

    if (files.length) {
      const filename = this.fileInputTarget.files[0].name
      if (/['"%]/.test(filename)) {
        this.errorMessageValue = this.invalidCharacterErrorValue
      }
      this.filenameTarget.innerHTML = filename
    }
  }
}
